export const useCacheDefaultOptions = {
  dependencyTracking: true,
  initialResponse: null,
  deepCompare: true,
};
